import { Modal } from 'app/shared/components/modals/Modal';
import { ModalWrapper } from '@styles/StyledDiv';
import { IStipReviewModalProps } from '../interfaces';

import { StipsReview } from './StipsReview';

export const StipReviewModal = ({ open, onClose, contactStipData, stipReviewModalPosition, confidenceScore}: IStipReviewModalProps) => (
  <Modal
    hideBackdrop
    title="STIPS Review"
    open={open}
    resetPosition={stipReviewModalPosition}
    dialogWidth="1200px"
    onClose={onClose}
  >
    <ModalWrapper style={{ paddingRight: 0 }}>
      <StipsReview contactStipData={contactStipData} confidenceScore={confidenceScore} />
    </ModalWrapper>
  </Modal>
);
